import React, { useEffect, useState, useContext } from 'react'
import _ from "lodash"
import { useTranslation } from 'react-i18next'

import useFetchStatus from "customHooks/useFetchStatus"
import CustomTable from "main_views/components/ReactTable"
import TitleWithBtn from "main_views/components/Titles/TitleWithBtn"
import { getTicketStep2, handleTicket, addDate } from "main_views/Tasks/handler"
import PreviewModal from "main_views/Tasks/previewModal"
import { UserContext } from "context/auth";
import ReRequestModal from "main_views/form/request/reRequestModal"

function RejectedTickets() {

    let { t } = useTranslation()

    let { user: currentUser } = useContext(UserContext)

    let staffIdQuery = [
        { field: "requestedBy", value: currentUser.id },
        { field: "isApproved", value: false },
        { field: "inProgress", value: false },
        { field: "wasCanceled", value: false },
        { field: "isCompleted", value: false },
    ]

    let [selectedTicket, setSelectedTicket] = useState()

    let [pagination, setPagination] = useState({ orderBy: 'number' })
    let [tickets, ticketError, isTicketLoading] = useFetchStatus(`tickets`, {}, [selectedTicket, pagination], staffIdQuery, false, pagination)
    let [loadedTickets, setLoadedTickets] = useState([])

    let [staffs, staffsError, isStaffsLoading] = useFetchStatus(`staff`, {}, [], null)
    let [filteredData, setFilteredData] = useState()

    // preview Request Modal
    let [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false)
    let [previewingTicket, setPreviewTicket] = useState()
    let [ticketList, setTicketList] = useState([])
    let [isHandled, setHandled] = useState(false)

    // re-request Modal
    let [selectedFormToReRequest, setSelectedFormToReRequest] = useState()

    let fetchMoreData = () => {
        let lastVisibleTicketNumber = _.last(_.values(tickets)).number
        setPagination({ ...pagination, lastVisible: lastVisibleTicketNumber })
        setHandled(false)
    }
    
    useEffect(() => {

        let handle = async () => {
            tickets = await Promise.resolve(handler(_.values(tickets), staffs)).then(data => {
                return data
            })
            if (!_.isEmpty(tickets)) {
                setHandled(true)
                setTicketList(tickets)
            }
        }
        if (!isHandled) handle()
    }, [tickets])

    // merge the new fetched data with table body data
    useEffect(() => {
        setLoadedTickets(_.concat(loadedTickets, _.values(tickets)))
    }, [tickets])

    const previewTicket = (index) => {
        setPreviewTicket(filteredData[index])
        setIsPreviewModalOpen(true)
    }

    const Header = [
        {
            Header: "#",
            accessor: "number",
            type: "string",
            sortable: true,
        },
        {
            Header: t('requester_name'),
            accessor: "requesterName",
            type: "string",
        },
        {
            Header: t('form_name'),
            accessor: "form.name",
            type: "string",
        },
        {
            Header: t('due_date'),
            accessor: "dueDate",
            type: "firestoreTime",
        },
        {
            Header: t('priority'),
            accessor: "priority",
            type: "priorityTxt",
        },
        {
            Header: t('state'),
            accessor: "step",
            type: "string",
        },
        {
            Header: t('open_at'),
            accessor: "openedAt",
            type: "firestoreTime",
        },
        {
            Header: t('date_and_time'),
            accessor: "date",
            type: "dateAndTime",
        },
        {
            Header: " ",
            buttonTitle: t('preivew'),
            type: "button",
            color: "info",
            isOutline: true,
            sortable: false,
            onClick: previewTicket,
        },
        {
            Header: " ",
            buttonTitle: t('re_request'),
            type: "reRequest_btn",
            color: "warning",
            isOutline: true,
            sortable: false,
            onClick: (requestInfo) => setSelectedFormToReRequest(requestInfo),
        },
    ]

    return (
        <div className="content">

            <TitleWithBtn
                title={t('rejected_requests')}
            />

            {/*Display Tickets list */}
            <CustomTable
                title={t('rejected_requests')}
                header={Header}
                loading={isTicketLoading}
                body={loadedTickets}
                hasSearchBar={true}
                searchBarTitle={t("search")}
                setFilterResult={setFilteredData}
                selectDateRangeBeforeExport={true}
                loadMoreBtn={{
                    onClick: fetchMoreData,
                    isDisabled: !isTicketLoading && _.isEmpty(tickets)
                }}
                dataQuery={staffIdQuery} // for search & export 
                dataHandler={(allTickets) => handler(allTickets, staffs)} // to handel the data after fetch
            />

            {/* Preview ticket modal */}
            {previewingTicket && (
                <PreviewModal
                    isOpen={isPreviewModalOpen}
                    toggle={() => setIsPreviewModalOpen(false)}
                    ticket={previewingTicket}
                    staffs={staffs}
                />
            )}

            {selectedFormToReRequest && (
                <ReRequestModal
                    toggle={() => setSelectedFormToReRequest(null)}
                    reRequestForm={selectedFormToReRequest}
                />
            )}

        </div>

    )
}

export default RejectedTickets




async function handler(tickets, staffs) {
    let filteredTickets = await Promise.all(_.map(tickets, (ticket) => ticket = addDate(ticket)))

    filteredTickets = await getTicketStep2(filteredTickets, staffs)

    return filteredTickets

}

let getInfo = async (tickets) => {

    await Promise.all(_.map(tickets, async (ticket) => {
        ticket = await handleTicket(ticket)

    }))

    return tickets

}